import { z } from 'zod/v3';

export const PolicyApprovalSignatureDTOSchema = z.object({
  version: z.number(),
  approvedAt: z.date(),
  approvedByName: z.string().nullable(),
  approvedByEmail: z.string().nullable(),
  approvedByTitle: z.string().nullable(),
  signatureStatus: z.enum(['UNSIGNED', 'SIGNED', 'TSA_VERIFIED']),
  overrideReason: z.string().nullable().optional(),
});

export type PolicyApprovalSignatureDTO = z.infer<typeof PolicyApprovalSignatureDTOSchema>;
